"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ts_validators_1 = require("ts-validators");
const getEnsuredProjectIdFromProcessor_1 = __importDefault(require("../getEnsuredProjectIdFromProcessor"));
const firebaseIsPathValid_1 = __importDefault(require("../../shared/firebaseIsPathValid"));
const getValueByPathFromUnknown_1 = __importDefault(require("../../shared/getValueByPathFromUnknown"));
const getEnsuredAppIdFromProcessor_1 = __importDefault(require("../getEnsuredAppIdFromProcessor"));
const General_1 = require("../../types/General");
const buildCallableFirebaseRealtimeDatabaseSet = (args) => async ({ entryVars: { [General_1.DEFINITION_PROP_NAMES.PATH_ENTRIES]: path, [General_1.DEFINITION_PROP_NAMES.VALUE]: value, }, processor, functionId, callbacks, executeProcesses, }) => {
    const projectId = (0, getEnsuredProjectIdFromProcessor_1.default)('firebaseRealtimeDatabaseSet', processor);
    const rootPath = `projects/${projectId}/${processor.root.isInDevelopment ? 'dataDevelopment' : 'data'}`;
    try {
        if (!(0, ts_validators_1.valueIsString)(path)) {
            throw new Error('Path must to be an string');
        }
        const validPathMessageError = (0, firebaseIsPathValid_1.default)(path);
        if (validPathMessageError) {
            throw new Error(validPathMessageError);
        }
        const appId = (0, getEnsuredAppIdFromProcessor_1.default)('firebaseRealtimeDatabaseSet', processor);
        await args.setFirebaseDatabase({
            appId,
            path: `${rootPath}/${path}`,
            value,
        });
        executeProcesses(functionId, callbacks[General_1.DEFINITION_PROP_NAMES.THEN]);
    }
    catch (error) {
        const errorMessage = `${(0, getValueByPathFromUnknown_1.default)(error, ['message']) || error}`.replace(rootPath, '');
        executeProcesses(functionId, callbacks[General_1.DEFINITION_PROP_NAMES.CATCH], errorMessage);
    }
};
exports.default = buildCallableFirebaseRealtimeDatabaseSet;
